export const getParams = () => {
  let _params = {};

  if (typeof window === 'undefined') return _params;

  const searchParams = new URLSearchParams(window.location.search);

  for (const [key, value] of searchParams.entries()) {
    _params = { ..._params, [key]: value };
  }

  return _params;
};
